module.exports = __webpack_public_path__ + "static/bg2-345ef948f13b7381376f721221a189dc.svg";